export default "__VITE_ASSET__CU61xvnl__"